export const COLORS = {
  bg: '#1B1B1F',
  sidebar: '#2D2D30',
  surface: '#3C3C3F',
  surfaceHover: '#444447',
  accent: '#F5A623',
  accentHover: '#FF6F00',
  textPrimary: '#FFFFFF',
  textSecondary: '#9E9E9E',
  textMuted: '#616161',
  success: '#34A853',
  danger: '#EA4335',
  warning: '#F5A623',
  border: '#484848',
  sidebarWidth: '240px',
};
